import config from '../Config/Config';

function getVariantId(variantName) {
  const productVariantDetails = config.Product.ProductVariants;
  const product = productVariantDetails.find(variant => variant.Name === variantName);
  return product ? product.Id : null;
}

export { getVariantId };
